import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DocumentSubSection } from 'src/app/core/types/document-sub-section';
import { FolderDocument } from 'src/app/models/server/folder-document';

@Injectable({
    providedIn: 'root',
})
export class DocumentsStateService {
    private onSelectedDocumentChange = new BehaviorSubject<{
        [folderId: string]: FolderDocument;
    }>({});

    private onSelectedSubSectionChange = new BehaviorSubject<DocumentSubSection>(null);

    /**
     * Emet un événement lorsque le document selectionné change.
     */
    public get onSelectedDocumentChange$() {
        return this.onSelectedDocumentChange.asObservable();
    }

    // Retourne le document selectionné.
    public getSelectedDocument(folderId: string): FolderDocument {
        return this.onSelectedDocumentChange.value[folderId];
    }

    /**
     * Indique que le document selectionné change.
     */
    public changeSelectedDocument(document: FolderDocument) {
        const documents = this.onSelectedDocumentChange.value;
        documents[document.folderId] = document;
        this.onSelectedDocumentChange.next(documents);
    }

    /**
     * Supprime le document sélectionné d'un dossier
     * @param folderId Identifiant du dossier.
     */
    public deleteSelectedDocument(folderId: string) {
        const documents = this.onSelectedDocumentChange.value;
        documents[folderId] = null;
        this.onSelectedDocumentChange.next(documents);
    }

    /**
     * Emet un événement lorsque la sous-section selectionné change.
     */
    public get onSelectedSubSectionChange$() {
        return this.onSelectedSubSectionChange.asObservable();
    }

    /**
     * Spécifie la sous-section selectionnée.
     */
    public changeSelectedSubSection(subSectionName: DocumentSubSection) {
        this.onSelectedSubSectionChange.next(subSectionName);
    }
}
